// extracted by mini-css-extract-plugin
module.exports = {"settings-cog":"_1WkCyEotdXYumvT5cgd9Xk"};